import { useDateTimeFormat } from '~/hooks';

export default function TimesheetDetails({ timesheet, deleteFrom }) {
  const dateTimeFormat = useDateTimeFormat();
  const start = deleteFrom || timesheet.start;
  return [timesheet.member?.name, `${dateTimeFormat.format(start)} - ${dateTimeFormat.format(timesheet.end)}`]
    .filter(Boolean)
    .join(' - ');
}
